import { CliError } from "@/lib/cli/cli-error";
import { readIssues } from "@/lib/issues/read-issues";
import { messageFrom } from "@/lib/message/message-from";
import { readString } from "@/lib/string/read-string";

export function throwResponseError(
  response: Response,
  payload: unknown,
  retryAfter: number | undefined,
): never {
  // Pre-router refusals use `error`; oRPC responses take precedence via `code`.
  const code = readString(payload, "code") ?? readString(payload, "error");
  const issues = readIssues(payload);

  throw new CliError(
    messageFrom(response.status, payload) +
      (response.status === 429 && retryAfter !== undefined
        ? ` Retry in ${retryAfter}s.`
        : ""),
    1,
    {
      status: response.status,
      ...(code ? { code } : {}),
      ...(issues ? { issues } : {}),
      ...(retryAfter === undefined ? {} : { retryAfterSeconds: retryAfter }),
    },
  );
}
